import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import type { Role, Scope } from "@/types/api";

interface Props {
  children: ReactNode;
  requireScope?: Scope;
  /** Minimum role. Backend enforces regardless — this just spares e.g. a
   * viewer from a page shell full of raw 403s. */
  requireRole?: Role;
}

export function RequireAuth({ children, requireScope, requireRole }: Props): JSX.Element {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (requireScope && auth.scope !== requireScope) {
    return <Navigate to="/" replace />;
  }
  if (requireRole && auth.role !== requireRole) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
